import _ from 'lodash';
import Vue from 'vue';
import tool from 'src/utils/tool';
import { i18n } from 'src/utils/localeUtil';

// 筛选需要的 list
export function filterColumns(columns, keys) {
  const result = [];
  const keySet = new Set(keys);
  columns.forEach((item) => {
    if (keySet.has(item.key)) {
      result.push(item);
    } else if (item.children && item.children.find(child => keySet.has(child.key))) {
      const children = item.children.filter(child => keySet.has(child.key));
      result.push({
        ...item,
        children,
      });
    }
  });
  return result;
}

// 筛选【不需要】的 list
export function filterExcludesColumns(columns, excludesKeys) {
  const result = [];
  const excludesKeysSet = new Set(excludesKeys);
  columns.forEach((item) => {
    // 当前节点不在需要排除的key中 并且没有子节点
    if (!excludesKeysSet.has(item.key) && !item.children) {
      result.push(item);
      // 当前节点不再需要排除的key中并且有子节点，过滤子节点
    } else if (!excludesKeysSet.has(item.key) && item.children) {
      const children = item.children.filter(child => !excludesKeysSet.has(child.key));
      result.push({
        ...item,
        children,
      });
    }
  });
  return result;
}

export function joinKey(prefix, key, col) {
  // 使用根节点的key，不加前缀（用于自定义列的基本信息列）
  if (col && col.useRootKey) {
    return key;
  }
  if (!prefix) {
    return key;
  }
  return [prefix, key].join('.');
}

/**
 * 对初始的 columns 配置做一些预处理
 * @param list list 原始 list
 * @param prefix key 重组后的前缀，默认为空
 * @returns formatter 后的 columns
 */
export function formatterStatsColumns(list, prefix = '') {
  // 解决 jsx 渲染的问题
  const h = new Vue().$createElement; // eslint-disable-line

  // 此处猜测是一个历史坑，通常很多列的hint属性与计算出来的hoverKey是相等的。 但还有一些列的hint属性不好改造？
  const getHoverKey = col => (col.hoverKey ? col.hoverKey : col.hint);

  const transformCol = (col) => {
    const title = _.isFunction(col.textFormatter) ? col.textFormatter(i18n.t(col.i18nPath), i18n.t) : i18n.t(col.i18nPath);
    const newCol = {
      ...col,
      title,
      align: col.align || 'right',
      key: joinKey(prefix, col.key, col), // 加前缀从嵌套路径中取值
      'header-align': col['header-align'] || 'right',
      'min-width': col['min-width'] || 150,
    };

    if (col.hoverKey || col.hint) {
      const hoverKey = getHoverKey(col);
      newCol.hoverKey = hoverKey;

      // 这个应该配置在组件里面而不是列表项中，之后需要移除
      newCol.renderString = () => (
        <checkbox-title-hover
          need-change={true}
          field={col.key}
          title={col.title}
          metric={col.i18nPath}
          show-placement="top"
          hint={hoverKey}
        >
          <span>{title}</span>
        </checkbox-title-hover>
      );
    }

    return newCol;
  };

  return list.map((col) => {
    const transformed = transformCol(col); // 转换自身
    const { children = [] } = col;
    if (children.length) {
      transformed.children = children.map(transformCol); // 转换二级子事件
    }
    return transformed;
  });
}

/**
 * 将 keys 转化成对应的列表配置项
 * @param {Array} keys 需要转化的项的 key 集合
 * @param {Array} allColumns 所有的列表项配置
 * @returns {Array} 转化后的列表项配置
 */
export function getDisplayColumns(keys, allColumns) {
  const pathMap = tool.getPathMap(allColumns);
  return keys.reduce((results, key) => {
    const path = pathMap[key] || '';
    const target = _.get(allColumns, path);
    if (!path || !target) {
      return results;
    }
    return results.concat(target);
  }, []);
}


/**
 * 格式化选项
 * @param options 筛选项
 */
export function formatterOptions(options) {
  return options
    .filter((item) => {
      if (typeof item.hidden === 'function') {
        return !item.hidden();
      }
      return !item.hidden;
    })
    .map(item => ({
      label: item.label || i18n.t(item.key), // 部分没有翻译的 options 用 label 表示
      value: item.id,
      reKey: item.reKey || '',
      disabled: !!item.disabled,
    }));
}
